_getEmailAvailability